"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TimelineHandler_1 = __importDefault(require("./TimelineHandler"));
var TickMark_1 = __importDefault(require("./TickMark"));
// Local constants for the TimelineLine component
var minuteSpan = 30;
var timeIncrement = 5;
var TimelineLine = function (props) {
    var _a, _b;
    var events = props.events, onChange = props.onChange, zoom = props.zoom, position = props.position;
    var _c = __read(react_1.default.useState(0), 2), left = _c[0], setLeft = _c[1];
    var _d = __read(react_1.default.useState(0), 2), delta = _d[0], setDelta = _d[1];
    var containerRef = (0, react_1.useRef)(null);
    var safeZoom = zoom < 0.1 ? 0.1 : zoom;
    var scaledMinute = Math.ceil(minuteSpan * safeZoom);
    var totalWidth = ((_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0;
    (0, react_1.useEffect)(function () {
        // Allowing some extra space for the timeline to move
        var correctionFactor = (totalWidth - (safeZoom * 400));
        var newLeft = (position * delta * scaledMinute) - correctionFactor;
        if (newLeft < 0) {
            newLeft = 0;
        }
        setLeft(newLeft);
    }, [zoom, position]);
    (0, react_1.useEffect)(function () {
        var firstEvent = events[0];
        var lastEvent = events[events.length - 1];
        setDelta(lastEvent.finish - firstEvent.start);
    }, [events]);
    var lastEventTime = 0;
    var buildEventBox = function (event, index) {
        var eventContinues = event.start <= lastEventTime;
        var left = "".concat(event.start * scaledMinute, "px");
        var width = "".concat((event.finish - event.start) * scaledMinute, "px");
        var style = {};
        if (event.eventType === "off") {
            return null;
        }
        if (event.eventType === "safety_event") {
            style = { left: left };
        }
        else {
            style = { left: left, width: width };
        }
        lastEventTime = event.finish;
        return (react_1.default.createElement("div", { key: index, className: "event ".concat(event.eventType, " ").concat(!eventContinues ? "start" : ""), style: style, title: "".concat(event.eventType, " ").concat(event.start, " - ").concat(event.finish) }));
    };
    var onSelectedRange = function (width) {
        props.onSelectedRange(Math.floor((left + (position * totalWidth)) / scaledMinute) - 1, Math.floor((left + width + (position * totalWidth)) / scaledMinute) - 1);
    };
    var zoomScaleTimeLine = timeIncrement;
    // Adjust the zoom scale for the timeline according to desing requirements
    if (safeZoom < 0.34) {
        zoomScaleTimeLine =
            safeZoom < 0.2
                ? Math.floor(timeIncrement * 40 * safeZoom)
                : Math.floor(timeIncrement * 10 * safeZoom);
    }
    var timeMarks = (0, react_1.useMemo)(function () {
        return Array.from({ length: (Math.ceil(delta / zoomScaleTimeLine) + 2) }, function (_, i) { return (react_1.default.createElement(TickMark_1.default, { key: i, scale: scaledMinute * zoomScaleTimeLine, timeMark: "".concat(i * zoomScaleTimeLine) })); });
    }, [zoomScaleTimeLine, delta, scaledMinute]);
    if (events.length === 0) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "display-container" },
        react_1.default.createElement("div", { className: "line" },
            react_1.default.createElement("div", { className: "line-tick" }),
            react_1.default.createElement("div", { className: "line-container", ref: containerRef, style: {
                    left: "-".concat(left, "px"),
                } }, events.map(function (event, index) {
                return buildEventBox(event, index);
            })),
            react_1.default.createElement("div", { className: "handler-container" },
                react_1.default.createElement(TimelineHandler_1.default, { value: position, onChange: onChange, zoom: zoom, onSelectedRange: onSelectedRange }))),
        react_1.default.createElement("div", { className: "time" },
            react_1.default.createElement("div", { className: "time-container", style: {
                    left: "-".concat(left, "px"),
                } }, timeMarks))));
};
exports.default = TimelineLine;
